<h3 class="session-type-heading">Choose your session location</h3>

@for (option of options(); track option.value) {
  <div
    class="session-type-option-card"
    [class.session-type-option-card--selected]="option.value === selectedValue()"
    (click)="onCardClick(option)"
  >
    <div class="session-type-option-radio">
      <div
        class="session-type-option-radio-button"
        [class.session-type-option-radio-button--selected]="option.value === selectedValue()"
      >
        @if (option.value === selectedValue()) {
          <div class="session-type-option-radio-check"></div>
        }
      </div>
      <input
        type="radio"
        [name]="radioGroupName"
        [value]="option.value"
        [checked]="option.value === selectedValue()"
        [id]="getOptionId(option)"
        (change)="onSelectionChange(option.value)"
        (keydown.enter)="onCardClick(option)"
        [attr.aria-label]="option.location ? option.label + ': ' + (option.location | formatAddress) : option.label"
      />
    </div>
    <label [for]="getOptionId(option)" class="session-type-option-label">
      <span class="session-type-option-label-main">{{ option.label }}</span>
      @if (option.location) {
        <span class="session-type-option-label-details">{{ option.location | formatAddress }}</span>
      }
    </label>
  </div>
}
